var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "recommended-list"
  }, [_c('div', {
    staticClass: "recommended-list-title",
    attrs: {
      "id": "hrefDom"
    }
  }, [_vm._v(_vm._s(_vm.$t('liveroom.recommended')))]), _vm._v(" "), _vm.rdList.length === 0 ? _c('blank-slot', {
    attrs: {
      "mediaAuto": false,
      "size": _vm.pageSize
    }
  }) : _vm._e(), _vm._v(" "), _c('room-list', {
    attrs: {
      "mediaAuto": false,
      "list": _vm.rdList
    },
    on: {
      "emitOnSkipLiveRoom": _vm.onSkipLiveRoom
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };